import name from './name.tpl'
console.log('user/xxxx')
console.log(name({name: 'zz'}))



// WEBPACK FOOTER //
// ./src/pages/user/base.js